import { render, staticRenderFns } from "./CarrierList.vue?vue&type=template&id=58454395"
import script from "./CarrierList.vue?vue&type=script&lang=js"
export * from "./CarrierList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports